// GoogleMapsProvider.js
import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const GoogleMapsContext = createContext();

export const GoogleMapsProvider = ({ children }) => {
  // Single loader for entire app - combines all your existing configs
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script', // Same ID as your existing ones
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyB95JaT-LA1RWVOaeBvuTU_Yf8eIsynnNc",
    libraries: ['places', 'geometry'], // Includes all libraries you need
    language: "en",
    region: "US"
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within GoogleMapsProvider');
  }
  return context;
};